module.exports = {
          srcSet: __webpack_public_path__ + "3d363c0f49bdaa7fae91ea3014660bb3-66.jpg"+" 66w",
          images:[ {path: __webpack_public_path__ + "3d363c0f49bdaa7fae91ea3014660bb3-66.jpg",width: 66,height: 66}],
          src: __webpack_public_path__ + "3d363c0f49bdaa7fae91ea3014660bb3-66.jpg",
          toString:function(){return __webpack_public_path__ + "3d363c0f49bdaa7fae91ea3014660bb3-66.jpg"},
          
          width: 66,
          height: 66
        }